import ErrorOutlineIcon from '@trustoo/components/ui/icon/ErrorOutlineIcon'
import clsx from 'clsx'

interface Props {
    className?: string
    error: string | boolean
    defaultErrorMsg?: string
    withIcon?: boolean
}

const InputErrorMessage = ({ className, error, defaultErrorMsg = '', withIcon = false }: Props) => {
    if (!error) return null

    const errorMessage = typeof error === 'string' ? error : defaultErrorMsg

    return (
        <div className={clsx('text-[red]', withIcon ? '' : 'font-bold', className)}>
            {withIcon ? (
                <div className="flex items-center gap-2">
                    <ErrorOutlineIcon size={18} />
                    <span>{errorMessage}</span>
                </div>
            ) : (
                errorMessage
            )}
        </div>
    )
}

export default InputErrorMessage
